const ENV_CONFIG_ATTRIBUTES = {
    ENV: 'ENV',
    BASE_PATH: 'BASE_PATH',
    BE_BASE_PATH: 'BE_BASE_PATH',
    MY_PAGES_URL: 'MY_PAGES_URL',
    AUTH_URL: 'AUTH_URL',
    AUTH_SCOPE: 'AUTH_SCOPE',
    AUTH_CLIENT_ID: 'AUTH_CLIENT_ID',
    AUTH_CALLBACK_URL: 'AUTH_CALLBACK_URL',
    AUTH_TOKEN_URL: 'AUTH_TOKEN_URL',
    AUTH_THEME: 'AUTH_THEME',
    CUSTOMER_SERVICE_URL: 'CUSTOMER_SERVICE_URL',
    ENABLE_DATA_LAYERS: 'ENABLE_DATA_LAYERS',
    MAIN_PAGE_URL: 'MAIN_PAGE_URL',
    GET_STARTED_PAGE_URL: 'GET_STARTED_PAGE_URL',
    TERMS_PAGE_URL: 'TERMS_PAGE_URL',
    ABOUT_WIFI_PAGE_URL: 'ABOUT_WIFI_PAGE_URL',
    LANGUAGE: 'LANGUAGE',
};

export { ENV_CONFIG_ATTRIBUTES };
